export default {
  SWIPING: 'swiping'
};